export default {
  SWIPING: 'swiping'
};